import { useState, useEffect } from "react";
import axios from "axios";
import useAuth from "../../auth/hooks/useAuth";

const useServices = params => {
  const [details, setDetails] = useState();
  const [status, setStatus] = useState();
  const { state: authState } = useAuth();

  useEffect(() => {
    try {
      (async () => {
        setStatus("LOADING");
        console.log(process.env.REACT_APP_API);
        const response = await axios({
          method: "post",
          url: `${process.env.REACT_APP_API}/downloadAvatar`,
          params,
          headers: {
            Authorization: `Bearer ${authState.access_token}`
          }
        });
        console.log(response.data)
        setDetails(response.data);
        setStatus("OK");
      })();
    } catch (e) {
      setStatus("ERROR");
      console.log("error")
    }
  }, []);

    return {
      details,
      status
    };
};

export default useServices;
